"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AthleticSbBoard = void 0;
class AthleticSbBoard {}
exports.AthleticSbBoard = AthleticSbBoard;